import { connect, ConnectedProps } from 'react-redux';

import DropContractUpload from '../components/DropContractUpload';

interface RootState {
    darkMode: boolean;
    isConsideredMobile: boolean;
    signedIn: boolean;
    stateOfOperations: string | null;
}
  
const mapStateToProps = (state: RootState) => ({
    darkMode: state.darkMode,
    isConsideredMobile: state.isConsideredMobile,
    signedIn: state.signedIn,
    stateOfOperations: state.stateOfOperations,
})
  
const connector = connect(mapStateToProps, {})
  
export type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(DropContractUpload)